import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';
import { LandingpageSuccessGuard } from './shared/services/landingpage-guard/success/landingpage-success-guard.guard';
import { LandingpageGuard } from './shared/services/landingpage-guard/landingpage.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./qmutator/qmutator.module').then(m => m.QmutatorModule),
  },
  {
    path: 'qcrop',
    loadChildren: () => import('./qcrop/qcrop.module').then(m => m.QcropModule),
  },
  {
    path: 'azure-subscription',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./azure-marketplace-landingpage/landingpage.component').then(
            c => c.LandingpageComponent
          ),
        canActivate: [MsalGuard, LandingpageGuard],
      },
      {
        path: 'success',
        loadComponent: () =>
          import(
            './azure-marketplace-landingpage/landingpage-success/landingpage-success.component'
          ).then(c => c.LandingpageSuccessComponent),
        canActivate: [LandingpageSuccessGuard],
      },
    ],
  },
  {
    path: '403',
    loadComponent: () =>
      import('./qmutator/components/forbidden/forbidden.component').then(
        c => c.ForbiddenComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./qmutator/components/not-found/not-found.component').then(
        c => c.NotFoundComponent
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: !BrowserUtils.isInPopup()
        ? 'enabledNonBlocking'
        : 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
